export interface Contract {
  code: string;
  laboratoryCode: number;
  logo: string;
  logoExtension: string;
  documents: ContractDocument[];
  texteLaboratoire: string;
  texteProduit: string;
}

export interface ContractDocument {
  documentCode: number;
  name: string;
  category: number;
  type: number;
  extension: string;
  url: string;
}

